import { onTTFB } from 'web-vitals/attribution';
import type { TTFBMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';

const onTimeToFirstByte = (report: (m: MetricReport) => void): void => {
  onTTFB((metric: TTFBMetricWithAttribution) => {
    const a = metric.attribution;
    report({
      name: 'time-to-first-byte',
      value: metric.value,
      unit: 'ms',
      rating: metric.rating,
      navigationType: metric.navigationType,
      id: metric.id,
      delta: metric.delta,
      attribution: {
        kind: 'ttfb',
        waitingDuration: a?.waitingDuration,
        cacheDuration: a?.cacheDuration,
        dnsDuration: a?.dnsDuration,
        connectionDuration: a?.connectionDuration,
        requestDuration: a?.requestDuration,
      },
    });
  });
};

export default onTimeToFirstByte;
